<template>
  <div>
    <svg
      width="390"
      height="64"
      viewBox="0 0 390 63"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      class="mobile"
    >
      <g>
        <rect
          width="229"
          height="64"
          fill="currentColor"
        />

        <path
          d="M229 64V0H229.333C269.042 0 302.415 27.1219 311.94 63.8513C327.521 43.2852 352.209 30 380 30H390V64H229Z"
          fill="currentColor"
        />
      </g>
    </svg>

    <svg
      width="768"
      height="64"
      viewBox="0 0 768 63"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      class="tablet"
    >
      <g>
        <rect
          y="30"
          width="24"
          height="34"
          fill="currentColor"
        />

        <path
          d="M744 30V64H24V30H219.333C238.929 30 256.982 36.605 271.387 47.7101C285.292 19.4484 314.375 0 348 0H583.333C623.042 0 656.415 27.1219 665.94 63.8513C681.521 43.2852 706.209 30 734 30H744Z"
          fill="currentColor"
        />

        <rect
          x="744"
          y="30"
          width="24"
          height="34"
          fill="currentColor"
        />
      </g>
    </svg>

    <svg
      width="1440"
      height="96"
      viewBox="0 0 1440 95"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      class="desktop"
    >
      <g>
        <rect
          y="45"
          width="180"
          height="51"
          fill="currentColor"
        />

        <path
          d="M1260 45V96H180V45H473C502.393 45 529.473 54.9075 551.081 71.5652C571.938 29.1726 615.562 0 666 0H1019C1078.56 0 1128.62 40.6829 1142.91 95.7769C1166.28 64.9278 1203.31 45 1245 45H1260Z"
          fill="currentColor"
        />

        <rect
          x="1260"
          y="45"
          width="180"
          height="51"
          fill="currentColor"
        />
      </g>
    </svg>
  </div>
</template>

<script>
  export default {
    name: 'Footer'
  }
</script>
